module.exports = __webpack_public_path__ + "img/bus.968a05c1.jpg";